import { gql } from "@apollo/client";

export const addCompanyPolicyNudge = gql`
  mutation addCompanyPolicyNudge($companyPolicyId: MongoID!, $title: String!, $description: String!) {
    CompanyPolicyNudge_Create(companyPolicyId: $companyPolicyId, title: $title, description: $description) {
        _id
    }
  }
`;


